import React from 'react';
import { ResourcesItem, ResourcesList } from 'redux-and-the-rest';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { GameScoreModel } from '../../../models/gameScoreModel';
import { RewardModel } from '../../../models/rewardModel';
import { createRewardPosition, getOrFetchRewardPositions } from '../../../redux/reducers/rewardPositionReducer';
import DecoratePanelReward from './DecoratePanelReward';
import { EnhancedReward, PercentageOffsets } from './types';

import { ApplicationState } from '../../../redux/types';
import { RewardPositionModel } from '../../../models/rewardPositionModel';

import './RewardsExpandableWidget.scss';

interface Props {
  groupName?: string;
  rewards: RewardModel[];
  claimedRewardGameScores: ResourcesItem<GameScoreModel>[];
  placementOfNewRewards: PercentageOffsets;
  rewardPositions: ResourcesList<RewardPositionModel>;
}

const RewardsGroup = ({
  groupName, rewards, claimedRewardGameScores, placementOfNewRewards, rewardPositions,
}: Props): React.ReactElement => (
  <>
    {groupName && (
      <div className="rewards-group-name">
        {groupName}
      </div>
    )}

    <div
      className="list reward-list"
    >
      {rewards.map((reward) => {
        /**
         * We go through all the available rewards and we match them against the scores that we have
         * won.
         */
        const rewardGameScores = claimedRewardGameScores.filter(({
          values: { chosenReward: { id = '' } = {} },
        }) => id === reward.id);

        const rewardCount = rewardGameScores.length;
        const enhancedReward: EnhancedReward = {
          reward,
          /**
           * A reward can only be used once, but we can win the same one multiple times and so they
           * need to stack.
           *
           * If any of these rewards have been placed on the island, we must subtract that many
           * out of the counter.
           */
          count: rewardCount === 0 ? 0 : rewardCount - rewardPositions.items.filter(
            ({ values: { gameScore: { chosenReward: { id } = {} } } }) => (id === reward.id),
          ).length,
        };

        return (
          <div key={reward.id} className="list-item">
            <DecoratePanelReward
              enhancedReward={enhancedReward}
              onSelected={() => {
                if (enhancedReward.count > 0) {
                  const {
                    values: {
                      island,
                    },
                  } = rewardGameScores[0];

                  if (island !== undefined) {
                    createRewardPosition({
                      islandId: island.id,
                    }, {
                      island,
                      gameScore: rewardGameScores[0].values,
                      flipped: false,
                      /**
                       * We default new items at a 50% size.
                       */
                      scalePercentage: 50,
                      ...placementOfNewRewards,
                    });
                  }
                }
              }}
            />
          </div>
        );
      })}
    </div>
  </>
);

const mapStateToProps = (
  { rewardPositions }: ApplicationState,
  { match: { params: { id: islandId } } }: RouteComponentProps<{ id: string; }>,
) => ({
  rewardPositions: getOrFetchRewardPositions(rewardPositions, {
    islandId, include: 'gameScore,gameScore.chosenReward',
  }),
});

export default withRouter(connect(mapStateToProps)(RewardsGroup));
